import './QuestionDiagram.css';

// Renders a question's inline SVG figure (graph, geometric diagram, or
// scatterplot). The markup is our own generated content (see
// backend/scripts/questionGenerators), never user-submitted, so injecting it
// directly is safe.
export default function QuestionDiagram({ svg }) {
  if (!svg) return null;
  return <div className="question-diagram" dangerouslySetInnerHTML={{ __html: svg }} />;
}
